export function lazy<T>(init: () => T): () => T {
	let wrapper: { content: T } | undefined;
	return () => {
		if (!wrapper) {
			wrapper = { content: init() };
		}
		return wrapper.content;
	};
}
